import React from "react"

export default ({ name, selector } = {}) => ({
  name,
  type: "border-radius",
  component: ({ value, onChange }) => {
    return (
      <div>
        <input type="range" value={value} onChange={onChange} />
      </div>
    )
  },
  css: value => {
    // TODO: we're phasing out using CSS in favor of inline styling.
    // To continue to support templates that need the CSS, we'll use CSS
    // if a `selector` is passed to the setting.
    if (!selector) return ""
    return `
      ${selector} {
        border-radius: ${value}px;
      }
    `
  }
})
